import { ERROR_CODE } from '../models/error.models';

export interface StorageRetryErrorBody {
	storage_retry?: boolean;
	retry?: boolean;
	error?: { error_code?: string | number };
}

/**
 * KO 2099 tras agotar reintentos del interceptor (NIF-646).
 * Distingue fallo transitorio de almacenamiento de retry OCR (2001, 2072…).
 */
export function isStorageRetryError(errorBody: unknown): boolean {
	if (!errorBody || typeof errorBody !== 'object') {
		return false;
	}

	const body = errorBody as StorageRetryErrorBody;

	if (!body.storage_retry || body.retry !== true) {
		return false;
	}

	const code = body.error?.error_code?.toString();
	return code === ERROR_CODE.STORAGE_NOT_AVAILABLE;
}
